<div class="dl-tekst-beschrijving-container">
    <div class="dl-tekst-beschrijving-titelbalk">
        <span>{{ 'TEKSTBESCHRIJVING.TITEL' | translate }}</span>
    </div>

    <div class="dl-tekst-beschrijving-inhoud" #scrollContainer [style.font-size.px]="fontGrootte">
        @if (isKlaar && cy) {
            @if (groepen.length > 0) {
                <div class="dl-tekst-regels">
                    @for (groep of groepen; track $index) {
                        @if (groep.condities || groep.consequenties) {
                            <div class="dl-tekst-conditieset">
                                <div class="dl-conditieset-header">{{ groep.titel }}</div>
                                @if (groep.condities && groep.condities.length > 0) {
                                    <div class="dl-conditieset-sectie">
                                        <div class="dl-conditieset-label">ALS:</div>
                                        <div class="dl-conditieset-regels">
                                            @for (item of groep.condities; track item.id) {
                                                <span class="dl-tekst-regel"
                                                      #regelElement
                                                      [class]="'status-' + item.status"
                                                      [class.is-vet]="item.isVet"
                                                      (mouseenter)="onMouseIn(item.nodes)"
                                                      (mouseleave)="onMouseOut()">
                                                    @for (frag of item.regel; track $index) {
                                                        <span [class.dl-grootheid]="frag.isGrootheid">{{ frag.tekst }}</span>
                                                    }
                                                </span>
                                            }
                                        </div>
                                    </div>
                                }
                                @if (groep.consequenties && groep.consequenties.length > 0) {
                                    <div class="dl-conditieset-sectie">
                                        <div class="dl-conditieset-label">DAN:</div>
                                        <div class="dl-conditieset-regels">
                                            @for (item of groep.consequenties; track item.id) {
                                                <span class="dl-tekst-regel"
                                                      #regelElement
                                                      [class]="'status-' + item.status"
                                                      [class.is-vet]="item.isVet"
                                                      (mouseenter)="onMouseIn(item.nodes)"
                                                      (mouseleave)="onMouseOut()">
                                                    @for (frag of item.regel; track $index) {
                                                        <span [class.dl-grootheid]="frag.isGrootheid">{{ frag.tekst }}</span>
                                                    }
                                                </span>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else if (groep.regels && groep.regels.length > 0) {
                            <div class="dl-tekst-groep">
                                @for (item of groep.regels; track item.id) {
                                    <span class="dl-tekst-regel"
                                          #regelElement
                                          [class]="'status-' + item.status"
                                          [class.is-vet]="item.isVet"
                                          (mouseenter)="onMouseIn(item.nodes)"
                                          (mouseleave)="onMouseOut()">
                                    @for (frag of item.regel; track $index) {
                                        <span [class.dl-grootheid]="frag.isGrootheid">{{ frag.tekst }}</span>
                                    }
                                </span>
                                }
                            </div>
                        }
                    }
                </div>
            }
        }
    </div>

    <div class="dl-tekst-beschrijving-footer">
        <valueslider [min]="6" [max]="20" [interval]="1" [reset]="STANDAARD_FONTGROOTTE" [(ngModel)]="fontGrootte" (ngModelChange)="onFontGrootteChange($event)"></valueslider>
    </div>
</div>
